import { Box } from '@material-ui/core'

export const DebugPresenter = (): JSX.Element => {
  console.log('rendered debug')

  return <Box></Box>
}
